import React, { forwardRef } from 'react';
import { HeaderModelData } from 'types/model';
import { useRegions } from 'components/header/hooks';
import { useSearchSponsoredData } from './hooks';
import { Searchbar } from './components/searchbar';
import { SearchHistoryContextProvider } from './components/search-history-provider';

interface SearchBarRootProps {
  model: HeaderModelData;
  hasForm?: boolean;
}

export const SearchBarRoot = forwardRef<HTMLDivElement, SearchBarRootProps>((props, containerRef) => {
  const { model, hasForm } = props;
  const {
    header: { logoImage },
    pinnedSuggestions,
  } = model;

  const { currentRegion } = useRegions(model);

  const {
    searchSuggestions,
    fetchSuggestions,
    resetServices,
    productRedirection,
    resetSponsoredProducts,
    resetSponsoredBrands,
  } = useSearchSponsoredData();

  const { suggestions, loading, error } = searchSuggestions;

  return (
    <SearchHistoryContextProvider>
      <Searchbar
        getSuggestions={fetchSuggestions}
        suggestions={suggestions}
        suggestionsLoading={loading}
        error={error}
        resetServices={resetServices}
        resetSponsoredProducts={resetSponsoredProducts}
        logoUrl={logoImage}
        productRedirectionUrl={productRedirection.redirectUrl}
        productRedirectionUrlLoading={productRedirection.loading}
        currentRegionId={currentRegion?.regionId}
        ref={containerRef}
        hasForm={hasForm}
        resetSponsoredBrands={resetSponsoredBrands}
        pinnedSuggestions={pinnedSuggestions || []}
      />
    </SearchHistoryContextProvider>
  );
});
